import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	inject,
	Input,
	OnChanges,
	Output,
	PLATFORM_ID,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { EventPhase } from '@angular/core/primitives/event-dispatch';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-modal',
	templateUrl: './modal.html',
	imports: [AngularSvgIconModule, CommonModule],
})
export class ModalComponent implements OnChanges, AfterViewInit {
	private readonly platformId = inject(PLATFORM_ID);

	@Input() closeButton = true;
	@Input() closeOnEscape = true;
	@Input() closeOnOutsideClick = true;
	@Input() title = '';
	@Input({ required: true }) showingModal = false;
	@Input() isMaxWScreenLG = false;
	@Input() showFooter = false;

	@Output() emitClose = new EventEmitter<void>();

	@ViewChild('dialog') modalRef!: ElementRef<HTMLDialogElement>;
	@ViewChild('footer') footerRef: ElementRef | undefined;

	scrollPosition = 0;

	ngAfterViewInit(): void {
		this.modalRef.nativeElement.addEventListener('cancel', (event) => {
			/* istanbul ignore else */
			if (event.eventPhase !== EventPhase.REPLAY) {
				event.preventDefault();
			}
			/* istanbul ignore else */
			if (this.closeOnEscape) {
				this.closeModal();
			}
		});

		this.modalRef.nativeElement.addEventListener('click', (event) => {
			/* istanbul ignore else */
			if (this.closeOnOutsideClick) {
				/* istanbul ignore else */
				if (event.target === this.modalRef.nativeElement) {
					this.closeModal();
				}
			}
		});

		this.modalRef.nativeElement.addEventListener('close', () => {
			this.emitClose.emit();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		/* istanbul ignore else */
		if (changes['showingModal']?.currentValue || this.showingModal) {
			if (changes['showingModal']?.firstChange) {
				setTimeout(() => {
					this.showModal();
				});
			} else {
				this.showModal();
			}
		} else if (!this.showingModal) {
			this.closeModal();
		}
	}

	showModal(): void {
		/* istanbul ignore else */
		if (isPlatformBrowser(this.platformId)) {
			this.modalRef?.nativeElement.showModal();
			this.scrollPosition = window.scrollY;
			GeneralHelper.bodyLock(true, this.scrollPosition);
		}
	}

	closeModal(): void {
		/* istanbul ignore else */
		if (isPlatformBrowser(this.platformId)) {
			this.modalRef?.nativeElement.close();
			this.showingModal = false;
			this.emitClose.emit();
			GeneralHelper.bodyLock(false, this.scrollPosition);
		}
	}
}
